module.exports = __webpack_public_path__ + "img/spec-zh.7883ee6f.jpg";